import { useState } from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import Skeleton from 'react-loading-skeleton';

import { useWindowSize } from '@/hooks/index';
import { breakPoints } from '@/constants/base';

import Button from '../Button/Button';

import styles from './InternetBanner.module.scss';

const InternetBanner = ({
  bannerData,
  size = '',
  dark = false,
  isHtml = false,
  children,
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [windowsX] = useWindowSize();

  const isRoamingHeader = !!bannerData?.countries.length;
  const renderTitleContent = () => {
    if (isHtml) {
      return (
        <h2
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: bannerData?.text }}
        />
      );
    }

    return <h2 className={styles.title}>{bannerData?.text}</h2>;
  };
  const headerStyle = isRoamingHeader
    ? {}
    : {
        backgroundImage: `url(${
          windowsX <= breakPoints.sm && bannerData?.mobile_background_image
            ? bannerData?.mobile_background_image
            : bannerData?.background_image
        })`,
        backgroundSize: bannerData?.mobile_background_imag
          ? '100% 100%'
          : 'cover',
        backgroundPosition: 'center',
      };

  return (
    <div
      style={headerStyle}
      className={classNames([
        styles.banner,
        {
          [styles.big]: size === 'L',
          [styles.medium]: size === 'M',
          [styles.small]: size === 'S',
          [styles.children]: bannerData?.countries?.length > 0,
          [styles.dark]: dark,
          [styles.redBanner]: isRoamingHeader,
        },
        { [styles.qr]: bannerData?.qrBlock },
      ])}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={`wrapper ${styles.wrapper}`}>
        <div className={styles.content}>
          {bannerData?.top_text && (
            <div className={styles.topText}>{bannerData?.top_text}</div>
          )}
          {renderTitleContent()}
          {bannerData?.bottom_text && (
            <div className={styles.bottomText}>{bannerData?.bottom_text}</div>
          )}
          {(bannerData?.slug ?? bannerData?.external_link) &&
            bannerData?.button_text && (
              <Button
                size='shortTrapezoid'
                variant='trapezoidRed'
                href={bannerData?.slug ?? bannerData?.external_link}
                Component={bannerData?.slug ? 'router' : 'a'}
              >
                {bannerData?.button_text}
              </Button>
            )}
          {bannerData?.countries?.length > 0 && children}
        </div>
      </div>
      {bannerData?.image && !isRoamingHeader && (
        <div className={styles.image}>
          {!isImageLoaded && <Skeleton width='100%' height='100%' />}
          <Image
            src={bannerData?.image}
            alt={bannerData?.top_text}
            title={bannerData?.top_text}
            layout='fill'
            onLoadingComplete={() => setIsImageLoaded(true)}
            style={{
              visibility: isImageLoaded ? 'visible' : 'hidden',
            }}
          />
        </div>
      )}
      {isRoamingHeader && bannerData?.background_image && (
        <div className={styles.roamingImage}>
          <Image
            src={bannerData?.background_image}
            alt={bannerData?.top_text}
            title={bannerData?.top_text}
            layout='fill'
          />
        </div>
      )}
    </div>
  );
};

export default InternetBanner;
